import {getSVGIcon} from "../utilities/globalUtilities";

/**
 * @function
 * @description - Show confirmation toast after adding to cart
 * @param {Element} $currentAddToCartBtn - Currently clicked 'Add to cart' button
 * @param {Boolean} fromIpaper - Product added from iPaper - true/false
 * @param {String} quantity - formatted quantity value for product
 * @param {Boolean} productRemoval - Product removal toast - true/false
 */
const showConfirmationToast = ($currentAddToCartBtn, fromIpaper, quantity, productRemoval) => {
    let isCartProductArea = false;
    let isMinicartProductArea = false;
    let isProductAlternativeArea = false;
    const isQuantityButton = $currentAddToCartBtn.hasClass("add-to-cart-quantity") || $currentAddToCartBtn.hasClass("decrease-quantity-btn") || $currentAddToCartBtn.hasClass("increase-quantity-btn");
    const isRemoveBtn = $currentAddToCartBtn.hasClass("tile-delete-confirmation-btn");

    if ((isQuantityButton || isRemoveBtn) && $currentAddToCartBtn.closest(".ct-cart-tile").length) {
        $currentAddToCartBtn = $currentAddToCartBtn.closest(".ct-cart-tile");
        isCartProductArea = true;
    }

    if (isQuantityButton && $currentAddToCartBtn.closest(".ct-minicart-tile").length) {
        $currentAddToCartBtn = $currentAddToCartBtn.closest(".ct-minicart-tile");
        isMinicartProductArea = true;
    }

    if ($currentAddToCartBtn.hasClass("ct-alternative-product-replace")) {
        isProductAlternativeArea = true;
    }

    const isCartReplaceProductAction = $currentAddToCartBtn.hasClass("js-alternative-product-replace");
    const $page = $(".page");
    const $addToCartBtn = $currentAddToCartBtn.hasClass("js-add-to-cart") || ((isCartProductArea || isMinicartProductArea) && $currentAddToCartBtn.hasClass("tile-delete-confirmation-btn")) || isProductAlternativeArea ? $currentAddToCartBtn : $currentAddToCartBtn.closest(".ct-tile-quantity").siblings(".js-add-to-cart");
    const pid = $addToCartBtn.data("pid");
    const isPDP = $addToCartBtn.data("container") == "pdp";
    const $qvContainer = $addToCartBtn.closest(".js-product-quickview");
    const isFromQuickView = $qvContainer.length > 0;
    let $addToCartMsg = $(".add-to-cart-messages");

    const DEFAULT_DELAY = 6000;
    const $addToCartActionsContainer = fromIpaper || isCartReplaceProductAction || isCartProductArea || isMinicartProductArea || isProductAlternativeArea ? $currentAddToCartBtn : (isFromQuickView ? $qvContainer.find(".prices-add-to-cart-actions") : (isPDP ? $(".prices-add-to-cart-actions") : $currentAddToCartBtn.closest(`.ct-product-tile.pid-${pid}`)));
    const delayTime = $addToCartActionsContainer.data("delay-time") || DEFAULT_DELAY;
    const isHorizontal = $addToCartActionsContainer.hasClass("ct-product-tile-horizontal");
    const inCartMsg = isCartReplaceProductAction || isMinicartProductArea || isProductAlternativeArea ? $currentAddToCartBtn.attr("data-in-cart-msg") : $addToCartActionsContainer.data("in-cart-msg");
    const removeFromCartMsg = isCartReplaceProductAction || isMinicartProductArea || isProductAlternativeArea ? $currentAddToCartBtn.attr("data-remove-from-cart-msg") : $addToCartActionsContainer.data("remove-from-cart-msg");
    const addedOneProduct = isCartReplaceProductAction || isMinicartProductArea ||isProductAlternativeArea ? $currentAddToCartBtn.attr("data-one-product-added") : $addToCartActionsContainer.data("one-product-added");

    const $productImagesContainer = (fromIpaper || isCartReplaceProductAction || isCartProductArea || isMinicartProductArea || isProductAlternativeArea) ? $currentAddToCartBtn : (isFromQuickView ? $qvContainer.find(".img-container") : (isPDP ? $(".product-images, .pdp-images-carousel") : (!isHorizontal ? $addToCartActionsContainer.find(".ct-image-container") : $addToCartActionsContainer.find(".ct-horizontal-image-container"))));
    const productName = isCartReplaceProductAction || isMinicartProductArea || isProductAlternativeArea ? $currentAddToCartBtn.attr("data-product-name") : (fromIpaper ? $currentAddToCartBtn.data("ipaper-text") : (isFromQuickView ? $qvContainer.find(".product-name").text() : (isPDP ? $(".product-name").text() : $addToCartActionsContainer.find(".pwc-tile--description").first().text())));
    const prodImage = $productImagesContainer.data("confirmation-image");
    const fallbackImg = prodImage && Object.prototype.hasOwnProperty.call(prodImage, "fallbackimage") ? `onerror="this.onerror=null;this.src='${prodImage.fallbackimage.url}'"` : "";
    const imgHtml = fromIpaper ? getSVGIcon("icon-loading-logo-red") : ((prodImage && prodImage != "" && prodImage.url) ? `<img class="img-fluid" alt="${prodImage.alt}" src="${prodImage.url}" ${fallbackImg} />` : `<img class="img-fluid" alt="${productName}" src=${prodImage} ${fallbackImg} />`);
    const addedQty = fromIpaper || productRemoval ? "" : quantity;
    const composedMessage = addedQty + " " + inCartMsg;
    const qtyHtml = fromIpaper || productRemoval ? "" : `<span class="d-block ct-confirmation-popup--msg ct-confirmation-popup--product-quantity">${ addedQty != "1 un" ? composedMessage : addedOneProduct }</span></div>`;
    const productRemovalMsg = `<span class="d-block ct-confirmation-popup--msg ct-confirmation-popup--product-removal">${removeFromCartMsg}</span></div>`;

    $addToCartMsg.append(`<div class="toast-body add-to-basket-alert d-flex">${imgHtml}<div><span class="d-block ct-confirmation-popup--product-name pwc-font--primary-bold">${productName}</span>${productRemoval ? productRemovalMsg : qtyHtml}</div>`);

    // Shows toast
    window.confTimeout = setTimeout(() => {
        $addToCartMsg.toast("show");
        $page.addClass("is-confirmation-popup-shown");
    }, delayTime);

    // Cleans toast
    $addToCartMsg.on("hidden.bs.toast", () => {
        $(".add-to-basket-alert").remove();
        $page.removeClass("is-confirmation-popup-shown");
    });

    if (fromIpaper) {
        const grandTotal = $currentAddToCartBtn.data("grand-total");
        const hideZeroPrice = $currentAddToCartBtn.data("hide-zero-price");

        // Update MiniCart Total
        const $minicartTotal = $(".minicart-grandtotal");
        const priceText = hideZeroPrice === true ? "" : grandTotal;

        if ($minicartTotal.length) {
            $minicartTotal.text(priceText);
        }

        // Remove input
        $currentAddToCartBtn.remove();
    }
};

/**
 * @function
 * @description - Cleans the confirmation toast
 */
const cleanConfirmationToast = () => {
    const $page = $(".page");
    const $addToCartMsg = $(".add-to-cart-messages");

    if ($page.hasClass("is-confirmation-popup-shown") || $addToCartMsg.length) {
        clearTimeout(window.confTimeout);
        $addToCartMsg.remove();
    }
};

module.exports = {
    showConfirmationToast: showConfirmationToast,
    cleanConfirmationToast: cleanConfirmationToast
};
